import LottieAnimation from "./LottieAnimation";

export default LottieAnimation;
